import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { getApiUrl, getImgeUrl, getLanguages } from 'src/environments/environment';
import { handleError } from './utils/erro-handler';
import { AdminService } from './admin/admin.service';


@Injectable({
  providedIn: 'root'
})
export class PublicServiceService {
  readonly IMAGE_URL = getImgeUrl()
  readonly BASE_URL = getApiUrl()
  readonly SLIDER_URL = "sliders"
  readonly BLOGS_URL = "blogs"
  readonly PROJECTS_URL = "projects"
  readonly ARTICLE_URL = "articles"
  readonly BOOKS_URL = "books"
  readonly VISION_URL = "visions"
  readonly EVENT_URL = "events"
  readonly ABOUT_URL = "abouts"
  readonly BIOGRAPHY_URL = "biographies"
  readonly NEWS_PAPER_URL = "news-papers"
  readonly MENUSCRIPT_URL = "menuscripts"
  language = getLanguages().EN_US
  constructor(private http: HttpClient) { 
    this.language = Number(localStorage.getItem("language"))
  }



  getRecordList(url, filter) {
    return this.http.get(`${this.BASE_URL}/${url}/list-all/`, {params:filter})
      .pipe(
        catchError(handleError)
      );
  }

  getRecordHome(url) {
    return this.http.get(`${this.BASE_URL}/${url}/list-home/${this.language}`)
  }
  getRecordById(url, id) {
    return this.http.get(`${this.BASE_URL}/${url}/${id}`)
  }


}
